import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";

export const CancelDialog = ({ cancelRef, busy, onConfirm, onClose }) => (
  <AlertDialog open={!!cancelRef} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent data-testid="cancel-confirm-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle className="heading-upper text-[#144733]">Cancel booking {cancelRef}?</AlertDialogTitle>
        <AlertDialogDescription>
          This releases your vehicle and any reserved delivery slot. Demo payments are voided automatically.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="cancel-dialog-keep-btn">Keep booking</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} disabled={busy} className="bg-red-600 hover:bg-red-700" data-testid="cancel-dialog-confirm-btn">
          Yes, cancel it
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
